module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_flower-173de8f176c04e3916de0983c7d028f4.png";